import { render, staticRenderFns } from "./TemplateHistorical.vue?vue&type=template&id=384fceb4"
import script from "./TemplateHistorical.vue?vue&type=script&lang=js"
export * from "./TemplateHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports